import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Section } from '../Section';
import { TransformCTA } from '../TransformCTA';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <Section tone="ink" eyebrow="5 premium bonuses" title="And you’ll receive these 5 bonuses at no additional cost" subtitle="Designed to make Renal Decision Desk™ even faster to use during everyday practice." data-id="element-123" data-mp="1clzcskl6ss3y">
      <div className="space-y-6 sm:space-y-8" data-id="element-124" data-mp="257hethjzn9tp">
        {bonuses.map(bonus => <article key={bonus.tag} className="overflow-hidden rounded-3xl border border-white/12 bg-white/[0.05]" data-id="element-125" data-mp="20bk01fodibj1">
            <div className="bg-white/[0.04] px-2 pt-2 sm:px-4 sm:pt-4" data-id="element-126" data-mp="1ravi49vuzr0v">
              <img src={bonus.image} alt={`${bonus.title} mockup`} className="mx-auto block w-full max-w-2xl" loading="lazy" width={1254} height={1254} data-id="element-127" data-mp="ku0bdipa0x3x" />
            </div>

            <div className="p-5 sm:p-7" data-id="element-128" data-mp="1erk9wrz97w2r">
              <div className="flex flex-wrap items-center gap-2" data-id="element-129" data-mp="1jszxorstggou">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-cyan-brand px-3 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-130" data-mp="1jqdnsligdp3g">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-131" data-mp="1aq8jwlcgx8u1" />
                  {bonus.tag}
                </span>
                <span className="rounded-full border border-white/20 px-3 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-white/70 line-through" data-id="element-132" data-mp="w1cg50hg2hz8">
                  Value {bonus.value}
                </span>
                <span className="rounded-full bg-cta px-3 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-133" data-mp="r3kng48z6rtz">
                  Included free
                </span>
              </div>

              <h3 className="mt-4 font-display text-[21px] font-bold leading-tight text-white sm:text-2xl" data-id="element-134" data-mp="i3nu3pbn54sl">
                {bonus.title}
              </h3>
              <p className="mt-2 text-[15px] font-semibold italic leading-snug text-cyan-brand" data-id="element-135" data-mp="2jueju5gdtpqp">
                {bonus.tagline}
              </p>
              <p className="mt-3 text-[14px] leading-relaxed text-white/70" data-id="element-136" data-mp="2b1b8q3t7loz8">
                {bonus.intro}
              </p>

              <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-137" data-mp="262q4ltau6l5i">
                {bonus.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-138" data-mp="32qmop85hfylh">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-139" data-mp="2yr5lkldj3djh" />
                    <span className="text-[13.5px] font-medium leading-snug text-white/85" data-id="element-140" data-mp="2orwsrvueg4yp">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </article>)}
      </div>

      <TransformCTA tone="dark" label="I want the 5 bonuses included" sub="$195 in bonuses included at no extra cost" data-id="element-141" data-mp="1db6le9e8p73i" />
    </Section>;
}